import { DepartmentSectionList, SetDepartmentInSection } from "../../../types/permissions/departmentSectionInterface";
import { DepartmentSectionActionTypes, DepartmentSectionActions } from "../../actionTypes/permissions/departmentSectionActionTypes";


export const getDepartmentSectionList = (): DepartmentSectionActionTypes => ({
  type: DepartmentSectionActions.GET_DEPARTMENT_SECTION_LIST,
});

export const setDepartmentSectionList = (payload: DepartmentSectionList): DepartmentSectionActionTypes => ({
  type: DepartmentSectionActions.SET_DEPARTMENT_SECTION_LIST,
  payload
})

export const setDepartmentInSections = (payload: SetDepartmentInSection[]): DepartmentSectionActionTypes => ({
  type: DepartmentSectionActions.SET_DEPARTMENT_IN_SECTION,
  payload
})
